import { render, staticRenderFns } from "./ListsTable.vue?vue&type=template&id=2adca784&scoped=true"
import script from "./ListsTable.vue?vue&type=script&lang=js"
export * from "./ListsTable.vue?vue&type=script&lang=js"
import style0 from "./ListsTable.vue?vue&type=style&index=0&id=2adca784&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adca784",
  null
  
)

export default component.exports